import React from 'react';
import GameWindowHeader from "../InGameUI/GameWindowHeader";
import GameTabViewUI from "../InGameUI/Tabs/GameTabViewUI";
import GameData from "../../gameplay/model/GameData";
import GameWindowBg from "../InGameUI/GameWindowBg";
import agent from "../../agent";
import GameController from "../../gameplay/controllers/GameController";
import "./ModeratorStatistics.css";

export default class ModeratorStatistics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 0,
            teamGameDatas: [],
            teamStats: [],
            information: null
        };
    }

    componentDidMount() {
        let info = [];
        let serverInfo = [];
        for (let team of this.props.teams) {
            let currentGame = GameData.CurrentModeratorGameDatas[team.uuid];
            let year = currentGame.year - 1;
            year = year > 0 ? year : 0;

            currentGame["teamName"] = team.name;
            currentGame["uuid"] = team.uuid;

            if (currentGame.year > 0 && currentGame.state === 0) {
                // eslint-disable-next-line no-loop-func
                agent.GamePlay.stat(team.uuid, year, (resp) => {
                    let data = GameData.CreateGameData(resp);
                    data["teamName"] = team.name;
                    data["uuid"] = team.uuid;

                    serverInfo.push(data);

                    if (serverInfo.length >= 3) {
                        info = [];
                        this.props.teams.forEach(team => {
                            serverInfo.forEach(el => {
                                if (el.teamName === team.name)
                                    info.push(el);
                            })
                        });
                    }

                    this.setState({
                        teamGameDatas: info
                    })
                })
            } else {
                info.push(currentGame);
                this.setState({
                    teamGameDatas: info
                })
            }
        }

        this.openStatsPage(0);
    }

    openStatsPage(page) {
        if (this.state.teamGameDatas.length < 4) {
            setTimeout(() => {
                this.openStatsPage(0)
            }, 200);
            return;
        }

        this.setState({
            currentPage: page,
            information: this.getContent(page)
        });
    }

    checkIfCanSendWinners() {
        if (!this.state.teamStats[0] || this.state.teamStats.length < 4)
            return

        if (!localStorage.getItem('last-sended-stats-at')) {
            localStorage.setItem('last-sended-stats-at', JSON.stringify(Date.now()))
        }
        let lastSendedAt = parseInt(localStorage.getItem('last-sended-stats-at'));

        if (Date.now() - lastSendedAt >= 1000 * 60 * 5) {
            for (let stateData of this.state.teamStats) {
                // Но только 1 раз в 5 мин

                if (this.state.teamGameDatas[0].state === 5) {
                    if (!window.statsInfo)
                        window.statsInfo = {};

                    if (!window.statsInfo[stateData.uuid]) {
                        window.statsInfo[stateData.uuid] = {
                            fullCapital: stateData.fullCapital,
                            totalProfit: stateData.cleanProfit
                        }
                    }
                    localStorage.setItem('last-sended-stats-at', JSON.stringify(Date.now()))
                }
            }

            let counter = 0;
            for (let teamID in window.statsInfo) {
                setTimeout(() => {
                    agent.GamePlay.fixProfit(teamID, window.statsInfo[teamID], (res) => {
                        console.log(res);
                    })
                }, 100 + counter);
                counter += 100;
            }

            setTimeout(() => {
                window.statsInfo = {};
            }, 1000);
        }
    }

    getContent(page) {
        let content = [];
        let stats = [];
        let teamCount = 1;

        for (let team of this.state.teamGameDatas) {
            let info = GameController.calculateStatistics(team, GameData.CurrentModeratorGameDatas[team.uuid]);
            info["teamName"] = team.teamName;
            info["uuid"] = team.uuid;
            stats.push(info);
        }

        this.setState({
            teamStats: stats
        });

        switch (page) {
            case 0:
                content.push(<div className={"column-big"} key={0}>
                    <div className={"c-blue"}><b>Показатели</b></div>
                    <div className={"c-indigo"}><b>Объем перевезенных грузов (тонны нетто)</b></div>
                    <div className={"c-indigo"}><b>ДОХОДЫ ОТ ПЕРЕВОЗОК + ПРОЧИЕ ДОХОДЫ</b></div>
                    <div className={"c-indigo"}><b>ПРОЧИЕ ДОХОДЫ</b></div>
                    <div className={"c-indigo"}><b>Переменные расходы</b></div>
                    <div className={"c-oddOdd"}>Дизтопливо</div>
                    <div className={"c-evenEven"}>Электричество</div>
                    <div className={"c-blue"}><b>Итого переменные расходы</b></div>
                    <div className={"c-indigo"}><b>ВАЛОВАЯ ПРИБЫЛЬ</b></div>
                    <div className={"c-indigo"}><b>Операционные расходы</b></div>
                    <div className={"c-oddOdd"}>Персонал</div>
                    <div className={"c-evenEven"}>Сверхурочные и подрядчики</div>
                    <div className={"c-oddOdd"}>Материалы для ремонта</div>
                    <div className={"c-evenEven"}>Услуги связи</div>
                    <div className={"c-oddOdd"}>Прочие операционные расходы</div>
                    <div className={"c-evenEven"}>Безопасность</div>
                    <div className={"c-blue"}><b>Итого операционные расходы</b></div>
                    <div className={"c-indigo"}><b>EBITDA</b></div>
                    <div className={"c-oddOdd"}>Амортизация</div>
                    <div className={"c-indigo"}><b>ОПЕРАЦИОННАЯ ПРИБЫЛЬ</b></div>
                    <div className={"c-oddOdd"}>Проценты по займам</div>
                    <div className={"c-indigo"}><b>ПРИБЫЛЬ ДО НАЛОГОВ</b></div>
                    <div className={"c-oddOdd"}>Налог (30%)</div>
                    <div className={"c-indigo"}><b>ЧИСТАЯ ПРИБЫЛЬ</b></div>
                    <div className={"c-oddOdd"}>Нераспределенная прибыль предыдущего года</div>
                    <div className={"c-evenEven"}>Чистая прибыль</div>
                    <div className={"c-oddOdd"}>Нераспределенная прибыль этого года</div>
                </div>);
                for (let el of stats) {
                    el.beforeMinusAfter = el.beforeTaxesProfit - el.afterTaxesProfit;
                    el.lastPlusClean = el.lastYearProfit + el.cleanProfit;
                    el.dieselExpanses = Math.round(el.dieselExpanses);

                    for (let key in el) {
                        if (el[key])
                            el[key] = el[key].toLocaleString();
                    }

                    content.push(<div className={"column-mini"} key={teamCount}>
                        <div className={teamCount % 2 === 0 ? "c-blue" : "c-lightblue"}><b>{el.teamName}</b></div>

                        <div className="cols">
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.totalWeight}</div>
                        </div>

                        <div className="cols">
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.profit}</div>
                        </div>
                        <div className="cols">
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.otherRevenue}</div>
                        </div>

                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.dieselExpanses}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.electricityExpanses}</div>
                            <div className="c-evenEven"/>
                            <div className="c-odd-lightblue"/>
                            <div className="c-even-lightblue">{el.fuelExpanses}</div>
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.valProfit}</div>
                        </div>

                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.brigadesExpanses}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.contractorsExpenses}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{el.partsExpanses}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.communicationExpanses}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{el.otherExpanses}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.securityExpanses}</div>
                            <div className="c-evenEven"/>
                            <div className="c-odd-lightblue">{el.operationsSum}</div>
                            <div className="c-even-lightblue"/>
                        </div>

                        <div className="cols">
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.EBITDA}</div>
                            <div className="c-oddOdd">{el.depreciation}</div>
                            <div className="c-oddEven"/>
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.operationalProfit}</div>
                            <div className="c-oddOdd">{el.creditPercents}</div>
                            <div className="c-oddEven"/>
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.beforeTaxesProfit}</div>
                            <div className="c-oddOdd">{el.afterTaxesProfit}</div>
                            <div className="c-oddEven"/>
                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.cleanProfit}</div>
                            <div className="c-oddOdd"/>
                            <div className="c-oddEven">{el.lastYearProfit}</div>
                            <div className="c-evenOdd"/>
                            <div className="c-evenEven">{el.cleanProfit}</div>
                            <div className="c-oddOdd"/>
                            <div className="c-oddEven">{el.lastPlusClean}</div>
                        </div>
                    </div>);

                    teamCount++;
                }
                break;
            case 1:
                content.push(<div className={"column-big"} key={0}>
                    <div className={"c-blue"}><b>Показатели</b></div>
                    <div className={"c-indigo"}><b>Активы</b></div>
                    <div className="c-oddOdd">Основные средства</div>
                    <div className="c-blue"><b>Основные средства (остаточная стоимость)</b></div>
                    <div className={"c-indigo"}><b>ОБОРОТНЫЕ СРЕДСТВА</b></div>
                    <div className="c-oddOdd">Запасы/Запчасти</div>
                    <div className="c-evenEven">Дебиторская задолженность</div>
                    <div className="c-oddOdd">Наличные</div>
                    <div className="c-evenEven">ОБОРОТНЫЕ СРЕДСТВА</div>
                    <div className="c-blue"><b>активы</b></div>
                    <div className="c-indigo"><b>Пассивы</b></div>
                    <div className="c-indigo"><b>задолженность</b></div>
                    <div className="c-oddOdd">Кредиты и займы</div>
                    <div className="c-evenEven">Кредиторская задолженность</div>
                    <div className="c-blue"><b>ВСЕГО ОБЯЗАТЕЛЬСТВА</b></div>
                    <div className="c-indigo"><b>СОБСТВЕННЫЙ КАПИТАЛ</b></div>
                    <div className="c-oddOdd">Акционерный капитал</div>
                    <div className="c-evenEven">Нераспределенная прибыль</div>
                    <div className="c-blue"><b>ВСЕГО СОБСТВЕННЫЙ КАПИТАЛ</b></div>
                    <div className="c-indigo"><b>Пассивы</b></div>
                    <div className="c-oddOdd">Чистые заимствования</div>
                    <div className="c-evenEven">Чистый оборотный капитал</div>
                    <div className="c-oddOdd">Долговая нагрузка</div>
                    <div className="c-evenEven">Заёмная возможность</div>
                </div>);
                for (let el of stats) {
                    for (let key in el) {
                        if (el[key])
                            el[key] = el[key].toLocaleString();
                    }

                    content.push(<div className={"column-mini"} key={teamCount}>
                        <div className={teamCount % 2 === 0 ? "c-blue" : "c-lightblue"}><b>{el.teamName}</b></div>
                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.main}</div>
                            <div className="c-oddEven"/>
                            <div className="c-odd-lightblue"/>
                            <div className="c-even-lightblue">{el.mainLeft}</div>
                        </div>
                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.partsSum}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.debit}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{el.cash}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd"/>
                            <div className="c-evenEven">{el.money}</div>

                            <div className="c-odd-lightblue"/>
                            <div className="c-even-lightblue">{el.actives}</div>
                        </div>
                        <div className={"full"}/>
                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.creditBalance}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.creditDebt}</div>
                            <div className="c-evenEven"/>
                            <div className="c-odd-lightblue"/>
                            <div className="c-even-lightblue">{el.creditsSum}</div>
                        </div>

                        <div className={"full"}/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.funders}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.lastYearProfitBalance}</div>
                            <div className="c-evenEven"/>

                            <div className="c-odd-lightblue"/>
                            <div className="c-even-lightblue">{el.fullCapital}</div>

                            <div className="c-odd-blue"/>
                            <div className="c-even-blue">{el.passives}</div>

                            <div className="c-oddOdd"/>
                            <div className="c-oddEven">{el.cleanCredit}</div>
                            <div className="c-evenOdd"/>
                            <div className="c-evenEven">{el.cleanCapital}</div>
                            <div className="c-oddOdd"/>
                            <div className="c-oddEven">{el.debtPercent}%</div>
                            <div className="c-evenOdd"/>
                            <div className="c-evenEven">{el.debtAbility}</div>
                        </div>
                    </div>);

                    teamCount++;
                }
                break;
            case 2:
                content.push(<div className={"column-big"} key={0}>
                    <div className={"c-blue"}><b>Показатели</b></div>
                    <div className="c-oddOdd">Грузооборот (т)</div>
                    <div className="c-evenEven">Накопленный опыт</div>
                    <div className="c-oddOdd">Индекс удовлетворенности клиентов</div>
                    <div className="c-evenEven">Уровень безопасности</div>
                    <div className="c-oddOdd">Инвестиции в оборудование</div>
                    <div className="c-indigo"><b>коэффициент рентабельности</b></div>
                    <div className="c-oddOdd">Возврат на активы (ROA)</div>
                    <div className="c-evenEven">Возврат на собственный капитал (ROE)</div>
                    <div className="c-oddOdd">Возврат на прим. капитал (ROCE)</div>
                    <div className="c-indigo"><b>коэффициент прибыльности</b></div>
                    <div className="c-oddOdd">Средняя цена за тонну (руб.)</div>
                    <div className="c-evenEven">GrossMargin (%)</div>
                    <div className="c-oddOdd">EBITDA (%)</div>
                    <div className="c-evenEven">Operating Profit (%)</div>
                    <div className="c-oddOdd">NetProfit (%)</div>
                    <div className="c-indigo"><b>коэффициент использования трудозатрат</b></div>
                    <div className="c-oddOdd">Коэффициент использования трудозатрат</div>
                    <div className="c-evenEven">Неиспользованные трудозатраты (руб.)</div>
                    <div className="c-oddOdd">Коэффициент использования локомотивов</div>
                    <div className="c-evenEven">Коэффициент порожнего пробега</div>
                    <div className="c-indigo"><b>КОЭФФИЦИЕНТЫ ОБОРАЧИВАЕМОСТИ</b></div>
                    <div className="c-oddOdd">Дебиторская задолженность (дней)</div>
                    <div className="c-evenEven">Запасов и материалов (дней)</div>
                    <div className="c-oddOdd">Кредиторской задолженности (дней)</div>
                    <div className="c-evenEven">Основных средств (лет)</div>
                    <div className="c-oddOdd">Всех активов (лет)</div>
                </div>);
                for (let el of stats) {
                    content.push(<div className={"column-mini"} key={teamCount}>
                        <div className={teamCount % 2 === 0 ? "c-blue" : "c-lightblue"}><b>{el.teamName}</b></div>

                        <div className="cols">
                            <div className="c-oddOdd">{el.deliveredCargo.toLocaleString()}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.expCoal + el.expOther}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{el.npsCoal + el.npsOther}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.securityLevel}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{el.investments}</div>
                            <div className="c-oddEven"/>
                        </div>
                        <div className="full"/>

                        <div className="cols">
                            <div className="c-oddOdd">{el.ROA}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.ROE}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{isFinite(el.ROCE) ? el.ROCE + "%" : "-"}</div>
                            <div className="c-oddEven"/>
                        </div>
                        <div className="full"/>
                        <div className="cols">
                            <div className="c-oddOdd">{isFinite(el.avgTonnage) ? el.avgTonnage : "-"}</div>
                            <div className="c-oddEven"/>
                            <div
                                className="c-evenOdd">{isFinite(el.grossMargin) ? Math.round((el.grossMargin * 100)) + "%" : "-"}</div>
                            <div className="c-evenEven"/>
                            <div
                                className="c-oddOdd">{isFinite(el.EBITDAPercent) ? Math.round((el.EBITDAPercent * 100)) + "%" : "-"}</div>
                            <div className="c-oddEven"/>
                            <div
                                className="c-evenOdd">{isFinite(el.operatingProfit) ? Math.round((el.operatingProfit * 100)) + "%" : "-"}</div>
                            <div className="c-evenEven"/>
                            <div
                                className="c-oddOdd">{isFinite(el.netProfit) ? Math.round((el.netProfit * 100)) + "%" : "-"}</div>
                            <div className="c-oddEven"/>
                        </div>
                        <div className="full"/>
                        <div className="cols">
                            <div
                                className="c-oddOdd">{isFinite(el.brigadesUsage) ? Math.round(el.brigadesUsage * 100) + "%" : "-"}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{Math.round(el.unusedMoney).toLocaleString()}</div>
                            <div className="c-evenEven"/>
                            <div className="c-evenOdd">{el.locoUsage}</div>
                            <div className="c-evenEven"/>
                            <div className="c-evenOdd">{el.emptyMilesPercent}</div>
                            <div className="c-evenEven"/>
                        </div>
                        <div className="full"/>
                        <div className="cols">
                            <div className="c-oddOdd">{isFinite(el.debtDays) ? Math.round(el.debtDays) : "-"}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{isFinite(el.partsDays) ? Math.round(el.partsDays) : "-"}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{isFinite(el.creditDays) ? el.creditDays : "-"}</div>
                            <div className="c-oddEven"/>
                            <div className="c-evenOdd">{el.capitalYears}</div>
                            <div className="c-evenEven"/>
                            <div className="c-oddOdd">{isFinite(el.allActives) ? Math.round(el.allActives) : "-"}</div>
                            <div className="c-oddEven"/>
                        </div>
                    </div>);

                    teamCount++;
                }
                break;
            default:
                console.log("error!");
                break;
        }

        this.checkIfCanSendWinners();
        return content;
    }

    render() {
        let allStats = ["Отчёт о прибылях и убытках", "Балансовый отчёт", "Ключевые показатели деятельности"]
        let shortStats = ["Отчёт о прибылях и убытках"]

        let gd = GameData.CurrentModeratorGameDatas[this.props.teams[0].uuid] || {
            state: null,
            isInvestComplete: null,
            year: null
        };
        let content = <div className="moderator-statistics__body">
            <GameTabViewUI width={1330}
                           tabs={gd.state === 0 && !gd.isInvestComplete && gd.year !== 0 ? allStats : shortStats}
                           onSelectedIndex={this.openStatsPage.bind(this)}/>
            <div className={"moderator-statistics__information"}>{this.state.information}</div>
        </div>;

        return <div className="moderator-statistics container__shadow">
            <div className="moderator-statistics__content container__content">
                <GameWindowHeader title="Статистика" isClosable={true} onHide={this.props.onHide}
                                  width={1360} height={40}/>
                <GameWindowBg width={1360} height={570} value={content}/>
            </div>
        </div>
    }
}
